import React, { memo, useMemo } from "react";
import { useFormikContext } from "formik";
import PropTypes from "prop-types";

function DependantFormField(props) {
  const { onDependencyChange = undefined, children = null } = props;
  const initialMount = React.useRef(true);
  const formikContext = useFormikContext({ name: props.dependencyName });
  const { values, setFieldValue } = formikContext;
  const dependencyValue = useMemo(() => values[props.dependencyName], [values, props.dependencyName]);
  const setFieldValueRef = React.useRef(setFieldValue);

  React.useEffect(() => {
    if (initialMount.current) {
      initialMount.current = false;
      return;
    }

    onDependencyChange && onDependencyChange({ setFieldValue: setFieldValueRef.current, dependencyValue });
  }, [dependencyValue, onDependencyChange]);

  if (typeof props.children === "function") {
    return props.children(formikContext);
  }

  return children;
}

DependantFormField.propTypes = {
  dependencyName: PropTypes.string.isRequired,
  onDependencyChange: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.node.isRequired, PropTypes.func.isRequired]),
};

export default memo(DependantFormField);
